import { Link } from '@inertiajs/react'
import { Button } from '@/components/ui/Button'
import { TessanLogo } from '@/components/ui/TessanLogo'

interface FooterProps {
  cta?: {
    label: string
    href: string
  }
  className?: string
}

export function Footer({ cta, className = '' }: FooterProps) {
  const currentYear = new Date().getFullYear()

  return (
    <footer className={`bg-tessan-cream border-t border-tessan-green/10 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo et copyright */}
          <div className="text-center md:text-left">
            <div className="text-tessan-green mb-2">
              <TessanLogo height={22} />
            </div>
            <p className="text-sm text-text-muted">
              © {currentYear} Tessan. Tous droits réservés.
            </p>
          </div>

          {/* Liens */}
          <nav className="flex flex-wrap justify-center gap-6 text-sm">
            <Link
              href="/faq"
              className="text-text-secondary hover:text-tessan-green transition-colors"
            >
              FAQ
            </Link>
            <Link
              href="/content"
              className="text-text-secondary hover:text-tessan-green transition-colors"
            >
              Ressources
            </Link>
            <a
              href="https://www.tessan.io"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-secondary hover:text-tessan-green transition-colors"
            >
              tessan.io
            </a>
            <a
              href="mailto:contact@tessan.io"
              className="text-text-secondary hover:text-tessan-green transition-colors"
            >
              Contact
            </a>
          </nav>

          {/* CTA optionnel */}
          {cta && (
            <Link href={cta.href}>
              <Button variant="primary">{cta.label}</Button>
            </Link>
          )}
        </div>
      </div>
    </footer>
  )
}
